import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";
import { toast } from "sonner";
import { Lock } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_c61eb3a6-eca5-4227-9115-b8ca96405a47/artifacts/zd13mtbj_F429A9FE-5AF6-4B77-9FE8-06E1627EDB41.PNG";

export default function AdminLogin() {
  const { user, login, checked } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (checked && user && user.role === "admin") {
    return <Navigate to="/admin" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-12">
          <img src={LOGO_URL} alt="" className="h-10 w-10 object-contain" />
          <span className="font-mono-tight text-zinc-300">Salside.Production</span>
        </div>
        <div className="flex items-center gap-3 mb-8">
          <Lock size={18} className="text-zinc-500" />
          <h1 className="text-3xl font-display tracking-tight">{t.admin.login_title}</h1>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form">
          <div className="field">
            <input
              type="email"
              placeholder=" "
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-email-input"
            />
            <label>{t.admin.email}</label>
          </div>
          <div className="field">
            <input
              type="password"
              placeholder=" "
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-password-input"
            />
            <label>{t.admin.password}</label>
          </div>
          <button type="submit" disabled={submitting} className="btn-primary w-full justify-center" data-testid="admin-submit-btn">
            {submitting ? "…" : t.admin.sign_in}
          </button>
        </form>
      </div>
    </div>
  );
}
